import { Injectable } from '@angular/core';
import { from, map } from 'rxjs';
import { assign, cloneDeep } from 'lodash-es';
import { FuseMockApiService, FuseMockApiUtils } from '@fuse/lib/mock-api';
import { customers as customersData } from './data';


@Injectable({
    providedIn: 'root'
})
export class CustomersMockApi {

    private _customers: any[] = customersData;

    /**
     * Constructor
     */
    constructor(private _fuseMockApiService: FuseMockApiService) {
        // Register Mock API handlers
        this.registerHandlers();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods 
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register Mock API handlers
     */
    registerHandlers(): void {
        // -----------------------------------------------------------------------------------------------------
        // @ Subscription - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onGet('api/apps/customers/all')
            .reply(() => {

                // Clone the customers
                const customers = cloneDeep(this._customers);

                // Sort the customers by the name field by default
                // customers.sort((a, b) => a.name.localeCompare(b.name));

                // Return the response
                return [200, customers];
            });

        // -----------------------------------------------------------------------------------------------------
        // @ Subscription Search - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onGet('api/apps/customers/search')
            .reply(({ request }) => {

                // Get the search query
                const query = request.params.get('query');

                // Clone the customers
                let customers = cloneDeep(this._customers);

                // If the query exists...
                if (query) {
                    // Filter the customers
                    customers = customers.filter(customer => customer.subject && customer.subject.toLowerCase().includes(query.toLowerCase()));
                }

                // Sort the customers by the name field by default
                // customers.sort((a, b) => a.name.localeCompare(b.name));

                // Return the response
                return [200, customers];
            });

        // -----------------------------------------------------------------------------------------------------
        // @ Contact - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onGet('api/apps/customers/customer')
            .reply(({ request }) => {

                // Get the id from the params
                const id = request.params.get('id');

                // Clone the customers
                const customers = cloneDeep(this._customers);

                // Find the customer
                const customer = customers.find(item => item.id === id);

                // Return the response
                return [200, customer];
            });

        // -----------------------------------------------------------------------------------------------------
        // @ Contact - POST
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onPost('api/apps/customers/customer')
            .reply(() => {

                // Generate a new customer
                const newCustomer = {
                    id: FuseMockApiUtils.guid(),
                    avatar: null,
                    name: 'New Contact',
                    emails: [],
                    phoneNumbers: [],
                    job: {
                        title: '',
                        company: ''
                    },
                    birthday: null,
                    address: null,
                    notes: null,
                    tags: []
                };

                // Unshift the new customer
                this._customers.unshift(newCustomer);

                // Return the response
                return [200, newCustomer];
            });

        // -----------------------------------------------------------------------------------------------------
        // @ Contact - PATCH
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onPatch('api/apps/customers/customer')
            .reply(({ request }) => {

                // Get the id and customer
                const id = request.body.id;
                const customer = cloneDeep(request.body.customer);

                // Prepare the updated customer
                let updatedCustomer = null;

                // Find the customer and update it
                this._customers.forEach((item, index, customers) => {

                    if (item.id === id) {
                        // Update the customer
                        customers[index] = assign({}, customers[index], customer);

                        // Store the updated customer
                        updatedCustomer = customers[index];
                    }
                });

                // Return the response
                return [200, updatedCustomer];
            });

        // -----------------------------------------------------------------------------------------------------
        // @ Contact - DELETE
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onDelete('api/apps/customers/customer')
            .reply(({ request }) => {

                // Get the id
                const id = request.params.get('id');

                // Find the customer and delete it
                this._customers.forEach((item, index) => {

                    if (item.id === id) {
                        this._customers.splice(index, 1);
                    }
                });

                // Return the response
                return [200, true];
            });
    }
}
